import { of } from 'rxjs';
import { Component, effect, inject, input, model } from '@angular/core';
import {
  Transaction,
  TransactionStatus,
} from '../../../../shared/schemas/transaction';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { ReadableTimePipe } from '../../../../shared/utils/pipes/readable-time.pipe';
import { ModalService } from '../../../../shared/utils/services/modal.service';
import { TransactionDetailsComponent } from '../transaction-details/transaction-details.component';
import { TransactionStatusFilterPipe } from '../../../../shared/utils/pipes/transaction-status-filter.pipe';
import { TransactionAccountFilterPipe } from '../../../../shared/utils/pipes/transaction-account-filter.pipe';

@Component({
  selector: 'qwiko-transaction-list',
  imports: [
    CommonModule,
    TranslocoModule,
    ReadableTimePipe,
    TransactionDetailsComponent,
    TransactionStatusFilterPipe,
    TransactionAccountFilterPipe,
  ],
  templateUrl: './transaction-list.component.html',
  styleUrl: './transaction-list.component.scss',
})
export class TransactionListComponent {
  modalService = inject(ModalService);
  hasRecordCount = input<boolean>(true);
  transactions = model.required<Transaction[]>();
  transactionCount = model<number>();
  loading = model.required<boolean>();
  selectedTransaction = model<Transaction | null>(null);
  transactionStatus = TransactionStatus;
  statusFilter = model<TransactionStatus>(this.transactionStatus.ALL);
  accountsFilter = model<string>('all');
  offset = model<number>(10);

  transactionsEffect = effect(() => {
    if (this.selectedTransaction()) {
      const foundTransaction = this.transactions().find(
        (transaction) => transaction.id === this.selectedTransaction()?.id,
      );
      if (foundTransaction) {
        this.selectedTransaction.set(foundTransaction);
      }
    }
  });

  showTransaction(transaction: Transaction) {
    this.modalService.closeAll();
    this.selectedTransaction.set(transaction);
    this.modalService.open('transaction-details-modal');
  }
}
